import { render, staticRenderFns } from "./VeHrPerformanceRuleList.vue?vue&type=template&id=5d682bcc&scoped=true"
import script from "./VeHrPerformanceRuleList.vue?vue&type=script&lang=js"
export * from "./VeHrPerformanceRuleList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d682bcc",
  null
  
)

export default component.exports